import { FC, useEffect } from 'react';
import { useInitLanguageUrl } from 'src/modules/locales/hooks/useInitLanguageUrl';
import { resetPreloadRetries } from 'src/utils/preloadRetry';
import { useInitDepositMethods } from 'src/hooks/useInitDepositMethods';
import { useAddGtmEffect, useTrackReferralLink } from 'react-easyrocket';
import { useOpenDepositOnSessionStart } from 'src/hooks/useOpenDepositOnSessionStart';
import { useDoSomethingOnEveryPage } from '../../hooks/useDoSomethingOnEveryPage';
import { useCentrifugeMessages } from 'src/hooks/useCentrifugeMessages';
import { useDoSomethingOnLogout } from 'src/hooks/useDoSomethingOnLogout';
import { useSetSmarticoUser } from 'src/hooks/useSetSmarticoUser';
import { useRevalidateEventOnRouteChange } from 'src/context/usePromoEvent';
import { useSmartlookIdentify } from 'src/modules/smartlook/useSmartlookIdentify';
import { PopUpPortal } from 'src/pages/CatchGame/components/PopUpPortal';
import { FreeSpinsHandler } from 'src/components/FreeSpinsHandler';
import { useLanguageSync } from 'src/hooks/useLanguageSync';
import { useOpenEventModal } from 'src/hooks/useOpenEventModal';
import { useAccountSearchParam } from 'src/hooks/useAccountSearchParam';
import { useCacheSession } from 'src/hooks/useCacheSession';
import { useTrackIncomingBonusTransaction } from 'src/hooks/useTrackIncomingBonusTransaction';
import { useBonusModalStore } from 'src/store';
import { useJackpotWin } from 'src/components/Modal/JackpotsWin/hooks/useJackpotWin';
import { useLiveChatAuth } from 'src/modules/livechat/useLiveChatAuth';
import { useCheckForNewLocalTournament } from 'src/modules/localTournamentNotification/hooks/useCheckForNewLocalTournament';
import { useCloseModalOnBackForward } from 'src/router/hooks/useCloseModalOnBackForward';
import { useClearSignUpCache } from 'src/components/Modal/SignupModal/hooks/useClearSignUpCache';
import { useAuthFlowSuccessCallback } from 'src/modules/authFlow/hooks/useAuthFlowSuccessCallback';
import { useOnesignal } from 'react-easyrocket/onesignal';
import { isDev, isProductionEnv } from 'src/api';
import { ONESIGNAL_APP_ID, ONESIGNAL_SAFARI_WEB_ID } from 'src/constants/oneSignal';
import { useModalNameLS } from 'src/hooks/useModalNameLS';
import { useResetQueriesOnLogout } from 'src/router/hooks/useResetQueriesOnLogout';
import { useTournamentWin } from 'src/router/hooks/useTournamentWin';
import { useGPTStateReset } from 'src/EXPERIMENTAL_LIB/modules/gpt/games';

export const SideEffects: FC = () => {
  const { setModal } = useBonusModalStore();

  useCloseModalOnBackForward();
  useLanguageSync();
  useInitLanguageUrl();
  useClearSignUpCache();
  useEffect(() => {
    resetPreloadRetries();
    setModal(null);
  }, []);
  useInitDepositMethods();
  useResetQueriesOnLogout();
  useTournamentWin();
  useCentrifugeMessages();
  useLiveChatAuth();
  useAddGtmEffect();
  useOpenDepositOnSessionStart();
  useTrackReferralLink();
  useTrackIncomingBonusTransaction();
  useDoSomethingOnEveryPage();
  useModalNameLS();
  useJackpotWin();
  useDoSomethingOnLogout();
  useSetSmarticoUser();
  useRevalidateEventOnRouteChange();
  useSmartlookIdentify();
  useOpenEventModal();
  useGPTStateReset();
  useAccountSearchParam();
  useCacheSession();
  useCheckForNewLocalTournament();
  useAuthFlowSuccessCallback();
  useOnesignal({
    config: {
      appId: ONESIGNAL_APP_ID,
      safari_web_id: ONESIGNAL_SAFARI_WEB_ID,
      notifyButton: {
        enable: true
      }
    },
    isEnabled: isProductionEnv && !isDev,
    debug: false
  });

  return (
    <>
      <PopUpPortal key="popup" />
      {/* вернуть, когда удалиться ивент */}
      {/* <CookiesBanner key="cookiesbanner" /> */}
      <FreeSpinsHandler key="freespinshandler" />
    </>
  );
};
